var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_basic-animation"},[(_vm.props.imageUrl)?_c('img',{staticClass:"animation-image",attrs:{"src":_vm.props.imageUrl},on:{"load":_vm.handleLoad,"error":_vm.handleError}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }